/**
 * Created by litai on 2017/6/21.
 */

import moment from 'moment'

import {data as cnData} from '@/assets/data/zh_cn'
import {data as twData} from '@/assets/data/zh_tw'

export const tools = {
    langue: () => {
        let type = 1
        if (window.sessionStorage.hrjkType) {
            type = window.sessionStorage.hrjkType
        }

        if (type == 1) {
            return cnData
        }

        if (type == 2) {
            return twData
        }

    },
    clone: (obj) => {
        return Object.assign({}, obj);
    },
    formatDate: (date) => {
        return moment(date).format('YYYY-MM-DD');
    },
    formatDateTime: (date) => {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    toast: (msg) => {
        mui.toast(msg, {duration: 'short'})
    },
    alert: (msg, title, ok) => {
        if (!title) {
            title = '提示'
        }
        mui.alert(msg, title, '确定', ok);
    },
    confirm: (msg, title, okCallback) => {

        if (!title) {
            title = '提示'
        }

        mui.confirm(msg, title, ['取消', '确定'], function (e) {
            if (e.index == 1) {
                if (okCallback) {
                    okCallback();
                }
            }
        });

    },
    showLoading: (msg) => {
        let param = {
            spinnerType: 'fading-circle'
        }
        if (msg) {
            param.text = msg
        } else {
            param.text = 'Loading'
        }
    },
    closeLoading: () => {
    }
    ,
    wxConfig: (self) => {
        var url = window.location
        url = encodeURI(url)

        self.$post('mobile/wx/sign', {url: url}, data => {
            wx.config({

                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。

                appId: data.appId, // 必填，公众号的唯一标识

                timestamp: data.timestamp, // 必填，生成签名的时间戳

                nonceStr: data.noncestr, // 必填，生成签名的随机串

                signature: data.signStr,// 必填，签名，见附录1

                jsApiList: ['getLocation', 'chooseCard'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

        })
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/tools.js